import React from 'react';
import { TableCell, TableRow, Link } from '@mui/material';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { ThemedTableCell } from 'components/common/CommonStyles';
import { Typography } from '@totalsoft/rocket-ui';

const OfferPartnerVerificationItem = ({ item, idx, onDownloadClick, toggleVerificationSummaryModal }) => {
  const [t] = useTranslation();

  const statusColor = item.statusCode === 'ERROR' ? 'error' : item.statusCode === 'COMPLETED' ? 'success' : null;

  return (
    <TableRow key={item.verificationId}>
      {item.sharepointUniqueId && item.fileNameFormat ? (
        <TableCell>
          {item.viewReport === true ? (
            <Link sx={{ cursor: 'pointer' }} disabled onClick={e => onDownloadClick(e, item)}>
              {item.verificationType}
            </Link>
          ) : (
            item.verificationType
          )}
        </TableCell>
      ) : (
        <TableCell>{item.verificationType}</TableCell>
      )}
      <TableCell>{item.partnerName}</TableCell>
      <ThemedTableCell color={statusColor}>
        <Typography fontWeight='bold'>{item.status}</Typography>
      </ThemedTableCell>
      <TableCell>{item.user}</TableCell>
      <TableCell>{t('DATE', { date: item.date })}</TableCell>
      <TableCell>{t('DATE', { date: item.validityDate })}</TableCell>
      <TableCell>
        {item.viewSummary === true ? (
          <Link sx={{ cursor: 'pointer' }} onClick={() => toggleVerificationSummaryModal(idx)}>
            {item.summaryTitle || ''}
          </Link>
        ) : (
          item.summaryTitle || ''
        )}
      </TableCell>
      <TableCell>
        {item.messageCode ? (
          item.messageCode
        ) : (
          <div>
            {item.comments?.split('\n').map((item, key) => {
              return <div key={key}>{item}</div>;
            })}
          </div>
        )}
      </TableCell>
    </TableRow>
  );
};

OfferPartnerVerificationItem.propTypes = {
  item: PropTypes.object.isRequired,
  downloadFile: PropTypes.func,
  toggleVerificationSummaryModal: PropTypes.func.isRequired,
  idx: PropTypes.number.isRequired,
  onDownloadClick: PropTypes.func.isRequired
};

export default OfferPartnerVerificationItem;
